const clinicMasterRouteList = {
  addOrEdit: "add-or-edit",
  icdMaster: "icd-master",
  icdUploadedList: "icd-uploaded-list",
  rateMaster:"rate-master",
  hpiMaster:"hpi-master",
  bloodGroupMaster:"blood-group-master",
  frequency:"frequency-master",
  diseaseMaster:"disease-master",
  complaintMaster:"complaint-master",
  cptGroupMaster:"cpt-group-master",
  RosMaster:"ros-master",
  denialCode:"denial-code-master",
  cptMaster:"cpt-master",
  loincMaster:"loinc-master",
  addOrEditLoinc:"add-or-edit-loinc",
  subDepartment:"sub-department",
  category:"category"
};

export default clinicMasterRouteList